<template>
  <el-form ref="formTablePage" :model="data" class="query-form-box clearfix">
    <el-form-item v-for="(v, i) in fieldLabelList" :key="i" :prop="v" :class="label[v].isNoFixedWidth ? 'noFixedWidth' : ''">
      <div class="form-item-label">{{ label[v] instanceof Object && label[v].name ? $t(label[v].name) : $t(label[v]) }}</div>
      <slot :name="v" />
    </el-form-item>

    <div class="query-form-btn-box form-btn-list">
      <cus-btn type="search" @click="Query" />
      <cus-btn type="reset" @click="Reset" />
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'FormTablePage',
  components: {},
  props: {
    // 表单数据对象
    data: {
      type: Object
    },
    // 表单项目标签对象
    label: {
      type: Object
    }
  },
  data() {
    return {
      fieldList: [],
      fieldLabelList: []
    }
  },
  mounted() {
    const self = this
    window.formTablePage = self

    this.formData = { ...this.data }
    for (var m in this.formData) {
      this.fieldList.push(m)
    }

    let labelList = { ...this.label }
    for (var m in labelList) {
      this.fieldLabelList.push(m)
    }
  },
  methods: {
    /**
     * 查询
     * @constructor
     */
    Query(type) {
      this.$emit('Query', type)
    },

    /**
     * 重置
     * @constructor
     */
    Reset() {
      this.$refs.formTablePage.resetFields()
      this.$emit('Reset')
      this.Query('Reset')
    }
  }
}
</script>

<style lang="scss">
.query-form-box {
  /*padding: 7px 25px 0 25px;*/
  .el-form-item {
    float: left;
    margin-right: 20px;
    margin-bottom: 0px;
    .el-form-item__content {
      width: 200px;
      height: 72px;
    }
  }

  .el-form-item.noFixedWidth{
    .el-form-item__content {
      width: auto;
    }
  }

  .query-form-btn-box {
    float: right;
    //height: 70px;
    display: flex;
    align-items: flex-end;
    // margin-bottom: 30px;
    margin-top:34px;
  }
}
</style>
